(function () {
    'use strict';

    angular.module("imApp").factory("externalApiService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1441,
                    parameters: parms || {}
                });
            },
            listMethods: function (parms) {
                return $ihttp.post({
                    method: 1443,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2221,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2222,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
